<template>
  <div>
    <div class="inner-content">
      <h2>{{ $t('contact') }}</h2>

      <p class="mb30 ml10" v-html="$t('we_are_accepting_questions_from_customers_using_the_contact_form')">
      </p>

      <h3 class="mb20">{{ $t('please_enter_your_contact') }}</h3>

      <form @submit.prevent="onSubmit()" method="post">
        <div class="contact-form-area clearfix mb30">
          <p class="required-icon">{{ $t('required') }}</p>
          <p class="ttl-pos">{{ $t('contents_of_contact') }}</p>
          <div class="contact-form-pos">
            <textarea
              v-model="contact.content"
              :class="[$v.contact.content.$error ? 'txt-area-error' : '']"
              data-private
            >
            </textarea>
            <div v-if="submitted && $v.contact.content.$error">
              <p class="error-txt" v-if="!$v.contact.content.required">{{ $t('contact_content_is_required') }}</p>
            </div>
          </div>
        </div>

        <h3 class="mb20">{{ $t('please_enter_your_customer_information') }}</h3>
        <div class="contact-form-area clearfix mb20">
          <p class="required-icon">{{ $t('required') }}</p>
          <p class="ttl-pos">{{ $t('doctor_name') }}</p>
          <div class="contact-form-pos">
            <input type="text"
              v-model="contact.name"
              :class="[$v.contact.name.$error ? 'input-error' : '']"
              class="mb5" />
            <p class="sample-txt">{{ $t('example_name') }}</p>
            <div v-if="submitted && $v.contact.name.$error">
              <p class="error-txt" v-if="!$v.contact.name.required">{{ $t('your_name_is_required') }}</p>
            </div>
          </div>
        </div>

        <div class="contact-form-area clearfix mb20">
          <p class="no-required-icon">&nbsp;</p>
          <p class="ttl-pos">{{ $t('facility_name') }}</p>
          <div class="contact-form-pos">
            <input type="text" v-model="contact.facilityName" />
          </div>
        </div>

        <div class="contact-form-area clearfix mb20">
          <p class="required-icon">{{ $t('required') }}</p>
          <p class="ttl-pos">{{ $t('email_address') }}</p>
          <div class="contact-form-pos">
            <input type="text"
              v-model="contact.email"
              :class="[$v.contact.email.$error ? 'input-error' : '']"
              class="mb5" />
            <p class="sample-txt">{{ $t('example_email') }}</p>
            <div v-if="submitted && $v.contact.email.$error">
              <p class="error-txt" v-if="!$v.contact.email.required">{{ $t('email_address_is_required') }}</p>
              <p class="error-txt" v-if="!$v.contact.email.email">{{ $t('the_format_of_the_email_address_is_different') }}</p>
            </div>
          </div>
        </div>

        <div class="contact-form-area clearfix mb50">
          <p class="required-icon">{{ $t('required') }}</p>
          <p class="ttl-pos">{{ $t('email_address_confirmation') }}</p>
          <div class="contact-form-pos">
            <input type="text"
            v-model="contact.confirmEmail"
            :class="[$v.contact.confirmEmail.$error ? 'input-error' : '']" />
            <div v-if="submitted && $v.contact.confirmEmail.$error">
              <p class="error-txt">{{ $t('email_addresses_do_not_match') }}</p>
            </div>
          </div>
        </div>
        <button type="submit" style="border: #ffa300" class="btn-base mb20">
          <a>
            <p>{{ $t('content_confirmation') }}</p>
          </a>
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import { required, email, sameAs, numeric } from "vuelidate/lib/validators"
import { mapState, mapGetters } from 'vuex'
import { Strings } from "@/js/commons/strings"
import { isLogin } from "@/js/commons/commons"

export default {
  data() {
    return {
      Strings: Strings,
      submitted: false,
      contact: {}
    };
  },
  created() {
    this.contact = this.$store.state.contact.contact
    if (isLogin()) {
      this.contact = this.$store.getters['contact/contactAutoFill']
    }
  },
  validations: {
    contact: {
      content: { required },
      name: { required },
      email: { required, email },
      confirmEmail: { required, email, sameAsEmail: sameAs('email') }
    }
  },
  mounted() {
    this.screenTracking(this.$t('contact_input'))
  },
  methods: {
    onSubmit() {
      this.submitted = true
      this.$v.contact.$touch()
      if (this.$v.contact.$error) return
      else {
        this.$store.dispatch('contact/setContact', this.contact)
        this.$router.push({ path: '/contact-confirm' }).catch(err => {})
      }
    }
  }
};
</script>
